/**
 * Convert a Vimeo or YouTube URL to a player-embed URL suitable for an <iframe src>.
 * Pass-through if it's already an embed URL or anything we don't recognise.
 */
export function toEmbedUrl(url) {
  if (!url) return '';
  const u = String(url).trim();

  // Already an embed URL — return as-is
  if (u.includes('player.vimeo.com/video/')) return u;
  if (u.includes('youtube.com/embed/')) return u;

  // Vimeo: https://vimeo.com/450948334  or  https://vimeo.com/450948334/37f9a6e9d7
  const vimeoMatch = u.match(/vimeo\.com\/(?:video\/)?(\d+)(?:\/([0-9a-fA-F]+))?/);
  if (vimeoMatch) {
    const id = vimeoMatch[1];
    const hash = vimeoMatch[2];
    const params = ['title=0', 'byline=0', 'portrait=0'];
    if (hash) params.unshift(`h=${hash}`);
    return `https://player.vimeo.com/video/${id}?${params.join('&')}`;
  }

  // YouTube long form: https://www.youtube.com/watch?v=ID&t=10s
  let ytMatch = u.match(/[?&]v=([A-Za-z0-9_-]{6,})/);
  // YouTube short form: https://youtu.be/ID  or  https://youtu.be/ID?t=10
  if (!ytMatch) ytMatch = u.match(/youtu\.be\/([A-Za-z0-9_-]{6,})/);
  // YouTube Shorts: https://www.youtube.com/shorts/ID
  if (!ytMatch) ytMatch = u.match(/youtube\.com\/shorts\/([A-Za-z0-9_-]{6,})/);

  if (ytMatch) {
    const id = ytMatch[1];
    const tMatch = u.match(/[?&]t=(\d+)/) || u.match(/[?&]start=(\d+)/);
    const start = tMatch ? `?start=${tMatch[1]}` : '';
    return `https://www.youtube.com/embed/${id}${start}`;
  }

  // Unknown / direct file — return as-is so a regular <video> source still works.
  return u;
}
